import apiFetch from '../apiFetch'

export default function (operationTypeId, token) {
  return apiFetch({ endPoint: `OperationType/${operationTypeId}`, method: 'DELETE', body: null, token: token })
}
